import ajax from "../utils/request.js";
//积分
//积分设备列表 GET /api/integral/lists
const integrallists = (data) => {
  return ajax.get("/api/integral/lists", data);
};
//添加设备积分    POST   /api/integral/add
const integraladd = (data) => {
  return ajax.post("/api/integral/add", data);
};
//编辑设备积分  POST /api/integral/edit
const integraledit = (data) => {
  return ajax.post("/api/integral/edit", data);
};
//编辑设备积分排序 POST /api/integral/editSort
const integraleditSort = (data) => {
  return ajax.post("/api/integral/editSort", data);
};
//删除设备积分    POST   /api/integral/delete
const integraldelete = (data) => {
  return ajax.post("/api/integral/delete", data);
};
//编辑推荐状态    POST   /api/integral/editTop
const integraleditTop = (data) => {
  return ajax.post("/api/integral/editTop", data);
};


//积分审核列表  POST /api/audit_integral/lists
const auditlists = (data) => {
  return ajax.post("/api/audit_integral/lists", data);
};
//审核  POST  /api/audit_integral/audit
const auditsh = (data) => {
  return ajax.post("/api/audit_integral/audit", data);
};
//批量审核  POST  /api/audit_integral/batch_operation
const batchoperation = (data) => {
  return ajax.post("/api/audit_integral/batch_operation", data);
};


//产品线 get  /audit_integral/getProducts
const getProducts = (data) => {
  return ajax.get("/api/audit_integral/getProducts", data);
};
//产品型号 get  /audit_integral/getModel
const getModel = (data) => {
  return ajax.get("/api/audit_integral/getModel", data);
};

export {
  integrallists,
  integraledit,
  integraleditTop,
  integraladd,
  integraldelete,
  auditlists,
  auditsh,
  integraleditSort,
  batchoperation,
  getProducts,
  getModel
}